// extracted by mini-css-extract-plugin
export var active = "_s6-1";
export var circle = "_s6-0";
export var completed = "_s6-2";
export var connector = "_s6-4";
export var connectorCompleted = "_s6-7";
export var connectorSpacer = "_s6-5";
export var iconStrokeOverride = "_s6-8";
export var labelContainer = "_s6-6";
export var pending = "_s6-3";